function Banner() {
  return (
    <>
      <section className="banner-section">
        <div className="container">
          <div className="banner-content">
            <div className="banner-content__text">
              <h2>Save big with your cheap car buy!</h2>
              <p>
              we are here with you. <span>24/7</span> Support.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
